import { useState, useEffect } from 'react';
import { getUserCreatedPuzzles } from '../services/api';

/**
 * The user's created puzzles (pending and private combined) for the Create
 * results screen. Fetched once on mount; a failed fetch leaves an empty list
 * and shows no error.
 *
 * @returns {{ createdPuzzles: Array, puzzlesLoading: boolean }}
 */
export const useAllCreatedPuzzles = () => {
  const [createdPuzzles, setCreatedPuzzles] = useState([]);
  const [puzzlesLoading, setPuzzlesLoading] = useState(true);

  useEffect(() => {
    fetchCreatedPuzzles();
  }, []);

  const fetchCreatedPuzzles = async () => {
    try {
      setPuzzlesLoading(true);
      const data = await getUserCreatedPuzzles();
      // Combine pending and private puzzles
      const allPuzzles = [
        ...(data.pending_puzzles || []),
        ...(data.private_puzzles || [])
      ];
      setCreatedPuzzles(allPuzzles);
    } catch (err) {
      console.error('Error fetching created puzzles:', err);
      // Don't show error to user, just show empty table
      setCreatedPuzzles([]);
    } finally {
      setPuzzlesLoading(false);
    }
  };

  return { createdPuzzles, puzzlesLoading };
};

export default useAllCreatedPuzzles;
